import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  deleteCredentialsError,
  deleteCredentialsSuccess,
  disableIntegrationError,
  disableIntegrationSuccess,
  enableIntegrationError,
  enableIntegrationSuccess,
  getStatusError,
  getStatusSuccess,
} from './actions'
import {
  DELETE_CREDENTIALS_REQUEST_ASYNC,
  DISABLE_INTEGRATION_REQUEST_ASYNC,
  ENABLE_INTEGRATION_REQUEST_ASYNC,
  STATUS_REQUEST_ASYNC,
} from './constants'

const getStatusEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      STATUS_REQUEST_ASYNC.INITIATE,
      ENABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DISABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DELETE_CREDENTIALS_REQUEST_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getGsuiteStatus(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getStatusSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getStatusError, error)))
    )

const enableIntegrationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ENABLE_INTEGRATION_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .enableGsuiteIntegration(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => enableIntegrationSuccess(response))
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(enableIntegrationError, error),
          addToast({ message: error.response?.message, type: 'error' })
        )
      )
  )

const disableIntegrationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DISABLE_INTEGRATION_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .disableGsuiteIntegration(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => disableIntegrationSuccess(response))
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(disableIntegrationError, error),
          addToast({ message: error.response?.message, type: 'error' })
        )
      )
  )

const deleteCredentialsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_CREDENTIALS_REQUEST_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .deleteGsuiteCredentials(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => deleteCredentialsSuccess(response))
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(deleteCredentialsError, error),
          addToast({ message: error.response?.message, type: 'error' })
        )
      )
  )

export default combineEpics(
  getStatusEpic,
  enableIntegrationEpic,
  disableIntegrationEpic,
  deleteCredentialsEpic
)
